const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function request(path, options = {}, token) {
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  // Auth
  signup: (body)                  => request('/auth/signup', { method:'POST', body }),
  login:  (body)                  => request('/auth/login',  { method:'POST', body }),
  logout: (token)                 => request('/auth/logout', { method:'POST' }, token),
  resetPassword: (body)           => request('/auth/reset-password', { method:'POST', body }),

  // Profile
  getMe:              (t)         => request('/profiles/me', {}, t),
  updateMe:           (body, t)   => request('/profiles/me', { method:'PATCH', body }, t),
  getNotifications:   (t)         => request('/profiles/me/notifications', {}, t),
  markNotifRead:      (id, t)     => request(`/profiles/me/notifications/${id}/read`, { method:'PATCH' }, t),
  getInstaSaves:      (t)         => request('/profiles/me/instagram-saves', {}, t),
  addInstaSave:       (body, t)   => request('/profiles/me/instagram-saves', { method:'POST', body }, t),

  // Events
  getEvents:          (t)         => request('/events', {}, t),
  getEvent:           (id, t)     => request(`/events/${id}`, {}, t),
  createEvent:        (body, t)   => request('/events', { method:'POST', body }, t),
  updateEvent:        (id,body,t) => request(`/events/${id}`, { method:'PATCH', body }, t),
  deleteEvent:        (id, t)     => request(`/events/${id}`, { method:'DELETE' }, t),
  addGuest:           (id,body,t) => request(`/events/${id}/guests`, { method:'POST', body }, t),
  addWishlistItem:    (id,body,t) => request(`/events/${id}/wishlist`, { method:'POST', body }, t),
  claimWishlistItem:  (id,wid,t)  => request(`/events/${id}/wishlist/${wid}`, { method:'PATCH' }, t),

  // Dishes
  suggestDish:        (body, t)   => request('/dishes', { method:'POST', body }, t),
  updateDish:         (id,body,t) => request(`/dishes/${id}`, { method:'PATCH', body }, t),
  deleteDish:         (id, t)     => request(`/dishes/${id}`, { method:'DELETE' }, t),
  rateDish:           (id,body,t) => request(`/dishes/${id}/rate`, { method:'POST', body }, t),
};
